// src/components/Popup.jsx
import React, { useEffect, useMemo, useRef } from 'react';

const BASE_FONT_PX = 22;
const LINE_HEIGHT  = 1.5;

const SIZE_SCALE = { md:1.0, lg:1.2, xl:1.4, xxl:1.75 };

export default function Popup({
  children,
  onClose,
  size = 'md',
  forceScale,
  maxWidth = '1100px',
  panelBg,
}) {
  const contentRef = useRef(null);

  const scale = useMemo(() => (
    typeof forceScale === 'number' && forceScale > 0
      ? forceScale
      : (SIZE_SCALE[size] || SIZE_SCALE.md)
  ), [size, forceScale]);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  useEffect(() => {
    const el = contentRef.current?.querySelector?.('[data-primary]');
    el?.focus();
  }, []);

  const overlayStyle = {
    position: 'fixed', inset: 0, zIndex: 9999,
    background: 'rgba(0,0,0,.5)', backdropFilter: 'blur(2px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 18,
  };

  const panelStyle = {
    background: panelBg || '#fff', color:'#111', borderRadius: 16 * scale,
    boxShadow:'0 18px 40px rgba(0,0,0,.25)',
    width: `min(${maxWidth}, calc(100vw - 48px))`,   // ← 更寬
    maxHeight: 'calc(100vh - 48px)', overflow: 'auto',
    fontSize: BASE_FONT_PX * scale, lineHeight: LINE_HEIGHT,
    padding: 20 * scale,
  };

  const globalBtnCss = `
    .popup-root button {
      min-height: ${56 * scale}px;
      padding: ${14 * scale}px ${20 * scale}px;
      border-radius: ${14 * scale}px;
      font-size: ${Math.round(BASE_FONT_PX * 1.1 * scale)}px;
    }
  `;

  return (
    <div
      className="popup-root"
      style={overlayStyle}
      onMouseDown={(e)=>{ if (e.target === e.currentTarget) onClose?.(); }}
    >
      <style>{globalBtnCss}</style>
      <div ref={contentRef} style={panelStyle} role="dialog" aria-modal="true">
        {children}
      </div>
    </div>
  );
}
